/* src/app/builder-screen-beta/floating-inspector/floating-inspector.component.scss */
.floating-inspector {
  position: fixed;
  z-index: 1000;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid #e8e8e8;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 420px;
  max-width: 90vw;
  min-height: 300px;
  max-height: 90vh;
}
.floating-inspector.dragging {
  -webkit-user-select: none;
  user-select: none;
  cursor: grabbing;
  resize: none;
}
.floating-inspector.dragging * {
  pointer-events: none;
}
.floating-inspector.resizing {
  -webkit-user-select: none;
  user-select: none;
}
.floating-inspector.resizing * {
  pointer-events: none;
}
@media (min-width: 1400px) {
  .floating-inspector {
    min-width: 450px;
    max-width: 700px;
    width: 520px;
  }
}
@media (max-width: 1199px) and (min-width: 768px) {
  .floating-inspector {
    min-width: 380px;
    max-width: 550px;
    width: 420px;
  }
}
@media (max-width: 768px) {
  .floating-inspector {
    display: none;
  }
}
.floating-inspector .resize-handle {
  position: absolute;
  background: transparent;
}
.floating-inspector .resize-handle.resize-right {
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  cursor: ew-resize;
}
.floating-inspector .resize-handle.resize-right:hover {
  background: rgba(24, 144, 255, 0.2);
}
.floating-inspector .resize-handle.resize-bottom {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  cursor: ns-resize;
}
.floating-inspector .resize-handle.resize-bottom:hover {
  background: rgba(24, 144, 255, 0.2);
}
.floating-inspector .resize-handle.resize-corner {
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  cursor: nw-resize;
}
.floating-inspector .resize-handle.resize-corner::after {
  content: "";
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  background:
    linear-gradient(
      -45deg,
      transparent 0%,
      transparent 40%,
      #ccc 40%,
      #ccc 60%,
      transparent 60%);
}
.floating-inspector .resize-handle.resize-corner:hover::after {
  background:
    linear-gradient(
      -45deg,
      transparent 0%,
      transparent 40%,
      #1890ff 40%,
      #1890ff 60%,
      transparent 60%);
}
.inspector-header {
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: grab;
  -webkit-user-select: none;
  user-select: none;
  transition: background-color 0.2s ease;
}
.inspector-header:hover {
  background: #f0f0f0;
}
.inspector-header:active {
  cursor: grabbing;
  background: #e6f7ff;
}
.inspector-header .header-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.inspector-header .header-content .drag-handle {
  color: #8c8c8c;
  font-size: 12px;
  opacity: 0.7;
}
.inspector-header:hover .inspector-header .header-content .drag-handle {
  opacity: 1;
  color: #1890ff;
}
.inspector-header .header-content .header-title {
  font-weight: 500;
  font-size: 14px;
  color: #262626;
}
.inspector-header .header-content .header-component-type {
  margin-left: auto;
}
.inspector-header .header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.inspector-search {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: white;
}
.inspector-search .ant-input-group {
  width: 100%;
}
.inspector-search .search-results-summary {
  margin-top: 8px;
  padding: 6px 0;
}
.inspector-search .search-results-summary .results-info,
.inspector-search .search-results-summary .no-results {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}
.inspector-search .search-results-summary .results-info .search-term,
.inspector-search .search-results-summary .no-results .search-term {
  color: #595959;
  font-style: italic;
}
.inspector-search .search-results-summary .no-results .search-term {
  color: #ff7875;
}
.user-guide {
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.user-guide :host ::ng-deep .ant-alert {
  border-radius: 6px;
  font-size: 13px;
}
.user-guide :host ::ng-deep .ant-alert .ant-alert-message {
  font-weight: 600;
  color: #1890ff;
}
.user-guide :host ::ng-deep .ant-alert .ant-alert-description {
  color: #595959;
  line-height: 1.4;
  margin-top: 4px;
}
.inspector-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
}
.inspector-content.mobile {
  padding: 16px 12px;
}
.inspector-content::-webkit-scrollbar {
  width: 8px;
}
.inspector-content::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 4px;
}
.inspector-content::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 4px;
  border: 1px solid #f8f9fa;
}
.inspector-content::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}
.inspector-content::-webkit-scrollbar-thumb:active {
  background: #6c757d;
}
:host ::ng-deep .ant-collapse {
  border: none;
  background: transparent;
}
:host ::ng-deep .ant-collapse .ant-collapse-item {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
:host ::ng-deep .ant-collapse .ant-collapse-item:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .ant-collapse .ant-collapse-item.priority-essential {
  border-color: #52c41a;
}
:host ::ng-deep .ant-collapse .ant-collapse-item.priority-essential .ant-collapse-header {
  background:
    linear-gradient(
      135deg,
      #f6ffed 0%,
      #d9f7be 100%);
  border-left: 4px solid #52c41a;
  color: #389e0d;
}
:host ::ng-deep .ant-collapse .ant-collapse-item.priority-common {
  border-color: #fa8c16;
}
:host ::ng-deep .ant-collapse .ant-collapse-item.priority-common .ant-collapse-header {
  background:
    linear-gradient(
      135deg,
      #fff7e6 0%,
      #ffd591 100%);
  border-left: 4px solid #fa8c16;
  color: #d46b08;
}
:host ::ng-deep .ant-collapse .ant-collapse-item.priority-advanced {
  border-color: #1890ff;
}
:host ::ng-deep .ant-collapse .ant-collapse-item.priority-advanced .ant-collapse-header {
  background:
    linear-gradient(
      135deg,
      #f0f5ff 0%,
      #adc6ff 100%);
  border-left: 4px solid #1890ff;
  color: #0050b3;
}
:host ::ng-deep .ant-collapse .ant-collapse-header {
  padding: 16px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
:host ::ng-deep .ant-collapse .ant-collapse-header:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
:host ::ng-deep .ant-collapse .ant-collapse-header .ant-collapse-arrow {
  font-size: 14px;
  transition: transform 0.2s ease;
}
:host ::ng-deep .ant-collapse .ant-collapse-content {
  border-top: none;
  background: #ffffff;
}
:host ::ng-deep .ant-collapse .ant-collapse-content .ant-collapse-content-box {
  padding: 20px;
}
.group-header-extra {
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
}
.group-header-extra .anticon {
  font-size: 12px;
  color: #8c8c8c;
}
.group-description {
  padding: 8px 16px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}
.group-description small {
  color: #8c8c8c;
  font-size: 12px;
  line-height: 1.4;
}
.property-controls.mobile {
  padding: 0 8px;
}
.property-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
}
.property-item:last-child {
  border-bottom: none;
}
.property-item:hover {
  background: #fafafa;
}
.mobile .property-item {
  padding: 16px 12px;
}
.empty-state,
.no-results {
  padding: 32px 16px;
  text-align: center;
}
.empty-state :host ::ng-deep .ant-empty,
.no-results :host ::ng-deep .ant-empty {
  margin: 0;
}
.empty-state :host ::ng-deep .ant-empty .ant-empty-image,
.no-results :host ::ng-deep .ant-empty .ant-empty-image {
  height: 60px;
  margin-bottom: 8px;
}
.empty-state :host ::ng-deep .ant-empty .ant-empty-description,
.no-results :host ::ng-deep .ant-empty .ant-empty-description {
  color: #8c8c8c;
  font-size: 12px;
}
.inspector-footer {
  border-top: 1px solid #f0f0f0;
  padding: 8px 16px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
}
.inspector-footer .footer-info small {
  color: #8c8c8c;
  font-size: 11px;
  font-family:
    "Monaco",
    "Menlo",
    "Ubuntu Mono",
    monospace;
}
.inspector-footer .footer-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.floating-inspector {
  animation: inspectorSlideIn 0.2s ease-out;
}
@keyframes inspectorSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.inspector-content.mobile .ant-collapse .ant-collapse-item .ant-collapse-header {
  padding: 16px 12px;
  font-size: 14px;
}
@media (max-width: 1199px) and (min-width: 768px) {
  .floating-inspector {
    min-width: 260px;
    max-width: 300px;
  }
  .property-item {
    padding: 10px 12px;
  }
}
@media (max-width: 767px) {
  .floating-inspector {
    display: none !important;
  }
}
/*# sourceMappingURL=floating-inspector.component.css.map */
